var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33594 7.27344V15.9304C1.33594 16.9593 2.16932 17.7927 3.19824 17.7927H16.2335C17.2624 17.7927 18.0958 16.9593 18.0958 15.9304V7.27344",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 7.27344V15.9304C1.33594 16.9593 2.16932 17.7927 3.19824 17.7927H16.2335C17.2624 17.7927 18.0958 16.9593 18.0958 15.9304V7.27344",
    stroke: "#3158F2",
    strokeWidth: 1.39673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16631 5.72813L8.6788 1.34705C9.30919 0.923378 10.1333 0.923378 10.7636 1.34705L17.2761 5.72813C18.373 6.46654 18.373 8.08022 17.2761 8.81863L11.8065 12.4985C10.5458 13.3468 8.89762 13.3468 7.63684 12.4985L2.16724 8.81863C1.06941 8.08022 1.06941 6.4656 2.16631 5.72813Z",
    fill: "#3158F2",
    stroke: "white",
    strokeWidth: 1.39673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16631 5.72813L8.6788 1.34705C9.30919 0.923378 10.1333 0.923378 10.7636 1.34705L17.2761 5.72813C18.373 6.46654 18.373 8.08022 17.2761 8.81863L11.8065 12.4985C10.5458 13.3468 8.89762 13.3468 7.63684 12.4985L2.16724 8.81863C1.06941 8.08022 1.06941 6.4656 2.16631 5.72813Z",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0879 8.86608V1.92269C15.0879 1.42954 14.6877 1.0293 14.1945 1.0293H5.26058C4.76743 1.0293 4.36719 1.42954 4.36719 1.92269V8.86608",
    fill: "#3158F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66406 1.92339C3.66406 1.04476 4.37679 0.332031 5.25542 0.332031H14.1894C15.068 0.332031 15.7807 1.04476 15.7807 1.92339V8.34432C15.7807 8.7298 15.4682 9.04229 15.0828 9.04229C14.6973 9.04229 14.3848 8.7298 14.3848 8.34432V1.92339C14.3848 1.81571 14.2971 1.72796 14.1894 1.72796H5.25542C5.14774 1.72796 5.05999 1.81571 5.05999 1.92339V8.34432C5.05999 8.7298 4.7475 9.04229 4.36203 9.04229C3.97655 9.04229 3.66406 8.7298 3.66406 8.34432V1.92339Z",
    fill: "#3158F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04688 3.41349H12.4072H7.04688Z",
    fill: "#3158F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 3.41349H12.4072",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04688 7.09904H12.4072H7.04688Z",
    fill: "#3158F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 7.09904H12.4072",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04137 12.0938L0.960938 18.1742",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4867 18.1742L12.4062 12.0938",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.23c8ad9846dac2763ee336226139f30e.svg";
export { ForwardRef as ReactComponent };